import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';
import { AuthService } from 'src/app/services/auth.service';
import { CustomValidators } from 'src/app/_helpers/customValidators';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PasswordComplexityComponent } from '../password-complexity/password-complexity.component';

@Component({
    selector: 'app-password-reset-dialog',
    templateUrl: './password-reset-dialog.component.html',
    styleUrls: ['./password-reset-dialog.component.css'],
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatDialogModule, MatFormFieldModule, PasswordComplexityComponent]
})
export class PasswordResetDialogComponent {
  private route = inject(ActivatedRoute);
  private accountService = inject(AccountService);
  private dialogRef = inject<MatDialogRef<PasswordResetDialogComponent>>(MatDialogRef);


  resetPasswordForm: UntypedFormGroup;
  error: string = null;
  requestSent = false;

  constructor() {

     this.resetPasswordForm = new UntypedFormGroup({
      'password': new UntypedFormControl(null, [CustomValidators.passwordHasUpper, CustomValidators.minLength(8), CustomValidators.passwordHasSpecial, CustomValidators.required]),
      'rptPassword': new UntypedFormControl(null,CustomValidators.required),
    },{validators: [CustomValidators.passwordsMatch]});

    this.resetPasswordForm.valueChanges.subscribe((changes) => {
      this.error = null;
    });

    this.dialogRef.disableClose = true;

  }

  onSubmit(): void {
    let password = this.resetPasswordForm.get('password').value as string;

    this.dialogRef.close(password);
  }


}
